import React, { useEffect, useState } from "react";
import SearchBar from "../components/SearchBar";
import FacilityList from "../components/FacilityList";


const Homepage = ({ facility }) => {

  const facilityData = typeof facility === "string" ? JSON.parse(facility) : facility;
  const [searchText, setSearchText] = useState("");
  const [selectedFacility, setSelectedFacility] = useState(null);
  const [viewMode, setViewMode] = useState("list");

  const allFacilitiesRaw = facilityData.flatMap(region =>
    (region.rivers || []).flatMap(river => {
      if (river.facilities && river.facilities.length > 0) {
        return river.facilities.map(facility => ({
          facility_id: facility.id || facility.facility_id,
          facility_name: facility.facility_name,
          river_name: river.river_name,
          region_name: region.region_name,
          near_town: facility.near_town || "",
          slug: facility.facility_slug,
          post_id: facility.post_id,
          label: [
            facility.facility_name,
            river.river_name,
            facility.near_town
          ].filter(Boolean).join(", "),
          type: "facility",
        }));
      }
      return [];
    })
  );


  const allFacilities = [
    ...new Map(allFacilitiesRaw.map(item => [item.label, item])).values()
  ];

  const searchLower = searchText.trim().toLowerCase();

  const suggestions = allFacilities.filter(item =>
    item.label?.toLowerCase().includes(searchLower)
  );


  const topFiveFacilities = facilityData
  .flatMap(region =>
    (region.rivers || []).flatMap(river =>
      (river.facilities || []).map(facility => ({
        ...facility,
        region_name: region.region_name,
        river_name: river.river_name
      }))
    )
  )
  .sort((a, b) => {
    // Parse the date string format: "DD-MM-YYYY HH:MM:SS am/pm"
    const parseDate = (dateStr) => {
      if (!dateStr) return new Date(0);
      
      // Split date and time
      const [datePart, timePart, period] = dateStr.split(' ');
      const [day, month, year] = datePart.split('-');
      const [hours, minutes, seconds] = timePart.split(':');
      
      // Convert to 24-hour format
      let hour24 = parseInt(hours);
      if (period?.toLowerCase() === 'pm' && hour24 !== 12) {
        hour24 += 12;
      } else if (period?.toLowerCase() === 'am' && hour24 === 12) {
        hour24 = 0;
      }
      
      // Create date object (month is 0-indexed in JS)
      return new Date(year, month - 1, day, hour24, minutes, seconds);
    };
    
    const dateA = parseDate(a.modified_date);
    const dateB = parseDate(b.modified_date);
    return dateB - dateA; // Descending order (newest first)
  })
  .slice(0, 5);

  console.log(topFiveFacilities,"topFiveFacilities")



  const highlightText = (text, query) => {
    const trimmedQuery = query?.trim();
    if (!trimmedQuery) return text;

    const escapedQuery = trimmedQuery.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(`(${escapedQuery})`, "ig");
    const parts = text.split(regex);

    return parts.map((part, index) =>
      index % 2 === 1 ? <strong key={index}>{part}</strong> : part
    );
  };


  const handleSelect = (item) => {
    console.log(item, "item");
  
    if (item.slug) {
      window.location.href = `/facility/${item.slug}`;
      return;
    }
  
    setSelectedFacility(item);
    setSearchText(item.label);
  };
  

  const handleChange = (value) => {
    setSearchText(value);
    if (value === "") {
      setSelectedFacility(null);
    }
  };
  const handleMapRedirect = () => {
    window.location.href = "/safewaters-wp/map";
  };
  const handleListRedirect = () => {
    window.location.href = "/safewaters-wp/list";
  }

  const handleSearchSubmit = (value) => {
    const query = encodeURIComponent(value.trim());
    window.location.href = `/list/search/${query}`;
  };
  useEffect(() => {
    const path = window.location.pathname;

    // adjust if your home path changes
    if (path === "/safewaters-wp/" || path === "/safewaters-wp") {
      setSearchText("");
      setSelectedFacility(null);
    }
  }, []);



  return (
    <div className="search-wrapper">
      <SearchBar
        value={searchText}
        onChange={handleChange}
        onSearch={handleSearchSubmit}
      />

      {searchText && !selectedFacility && suggestions.length > 0 && (
        <div className="search-suggestions">
          <div className="search-suggestions-wrap">
            {suggestions.map(item => (
              <div
                key={item.post_id}
                className="suggestion-item"
                onClick={() => handleSelect(item)}
              >
                {highlightText(item.label, searchText)}
              </div>
            ))}

          </div>
        </div>
      )}

      <div className="facilities-wrap">
        <h5>Latest</h5>
        <div className="facilities-toggle-wrap">
          <h5>All Facilities:</h5>
          <div className="facilities-toggle">
            <div className={`list-view`} onClick={handleListRedirect}>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 18H16.125C17.16 18 18 17.16 18 16.125V15.375C18 14.34 17.16 13.5 16.125 13.5H6V18ZM6 12H16.125C17.16 12 18 11.16 18 10.125V7.875C18 6.84 17.16 6 16.125 6H6V12ZM4.5 6V12H1.875C0.84 12 0 11.16 0 10.125V7.875C0 6.84 0.84 6 1.875 6H4.5ZM6 4.5H16.125C17.16 4.5 18 3.66 18 2.625V1.875C18 0.84 17.16 0 16.125 0H6V4.5ZM4.5 0V4.5H1.875C0.84 4.5 0 3.66 0 2.625V1.875C0 0.84 0.84 0 1.875 0H4.5ZM4.5 13.5V18H1.875C0.84 18 0 17.16 0 16.125V15.375C0 14.34 0.84 13.5 1.875 13.5H4.5Z" fill="#0F3557" />
              </svg>List
            </div>
            <div className={`list-view`} onClick={handleMapRedirect}>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 18L6 15.9L1.35 17.7C1.01667 17.8333 0.708333 17.796 0.425 17.588C0.141667 17.38 0 17.1007 0 16.75V2.75C0 2.53333 0.0626666 2.34167 0.188 2.175C0.313333 2.00833 0.484 1.88333 0.7 1.8L6 0L12 2.1L16.65 0.3C16.9833 0.166667 17.2917 0.204333 17.575 0.413C17.8583 0.621667 18 0.900667 18 1.25V15.25C18 15.4667 17.9377 15.6583 17.813 15.825C17.6883 15.9917 17.5173 16.1167 17.3 16.2L12 18ZM11 15.55V3.85L7 2.45V14.15L11 15.55Z" fill="#0F3557" />
              </svg>Map
            </div>
          </div>
        </div>
      </div>
      <FacilityList facilityData={topFiveFacilities} />

    </div>
  );
};

export default Homepage;
